module.exports = __webpack_public_path__ + "img/loading_circle.1e617b87.png";